import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, TextField, Box } from '@mui/material';

function SuburbSearch() {
  const [options, setOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Load the suburbs data once
    fetch('/Suburbs.json')
      .then(res => res.text())
      .then(text => {
        const lines = text.split('\n').slice(1); // Skip header
        const parsed = lines
          .map(line => {
            const p = line.split(',');
            if (p.length < 3) return null;
            return { label: `${p[0]}, ${p[1]} ${p[2]}`, state: p[1], suburb: p[0], postcode: p[2] };
          })
          .filter(item => item !== null);
        setOptions(parsed);
      })
      .catch(err => console.error("Error loading search data", err));
  }, []);

  const handleSelect = (event, value) => {
    if (value) {
      // Navigate to the dynamic page
      navigate(`/lights/${value.state}/${value.suburb}/${value.postcode}`);
    }
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 500, mt: 2, mb: 2, backgroundColor: 'white', borderRadius: 1 }}>
      <Autocomplete
        disablePortal
        options={options}
        onChange={handleSelect}
        renderInput={(params) => <TextField {...params} label="Search for your Suburb..." />}
      />
    </Box>
  );
}

export default SuburbSearch;